/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'zhouyu-1': {
    sides: [
      { f: 'wu', n: '孫策', l: '孫策、周瑜', w: 1 },
      { f: 'han', n: '劉繇', l: '樊能、于麋（橫江津）、張英（當利口）' },
    ],
    before: '揚州刺史劉繇佔了曲阿，派樊能、于麋屯橫江津，張英屯當利口，擋住袁術的人。孫策向袁術借兵東渡，到了歷陽。周瑜正在丹楊探望當太守的從父周尚，接到孫策的信，就帶兵和船糧來接應。',
    after: '橫江、當利都被攻下。孫策渡江打下秣陵、湖孰、江乘，進入曲阿，劉繇逃走，孫策的兵已有數萬人。孫策讓周瑜回去鎮守丹楊。',
    src: '《三國志·吳書·周瑜傳》〈孫策傳〉；裴注引《江表傳》（孫策令「發眾及船糧以濟大事」）',
  },
  'zhouyu-2': {
    sides: [
      { f: 'wu', n: '孫權', l: '周瑜、程普（左右督，各領萬人）', w: 1 },
      { f: 'shu', n: '劉備', l: '劉備（與吳軍并力）', w: 1 },
      { f: 'wei', n: '曹操', l: '曹操（軍中已有疾病）' },
    ],
    before: '曹操南下，劉琮投降，曹操得了荊州的水軍。孫權決定抗曹，派周瑜、程普為左右督，各領一萬人，和劉備一起迎擊，在赤壁相遇。',
    after: '曹軍營中有疾病，初次交戰就敗退，退到江北；周瑜等人在南岸。黃蓋看出曹軍船艦首尾相接，獻上火攻之計，後來火燒曹軍船隊。',
    src: '《三國志·吳書·周瑜傳》〈吳主傳〉',
  },
  'zhouyu-3': {
    sides: [
      { f: 'wu', n: '孫權', l: '周瑜、程普、呂蒙、甘寧、凌統', w: 1 },
      { f: 'wei', n: '曹操', l: '曹仁、徐晃（守江陵）' },
    ],
    before: '赤壁戰後曹操北還，留曹仁、徐晃守江陵。周瑜、程普進到南郡，和曹仁隔江相對。周瑜派甘寧先佔夷陵，曹仁分兵把甘寧圍住；周瑜用呂蒙的計策，留凌統守後方，自己和呂蒙去救，並派人砍柴堵住險道。',
    after: '夷陵解圍，曹軍夜逃時撞上柴道，丟下三百匹馬。吳軍渡到北岸約期大戰，周瑜擽陣時被流矢射中右脅；曹仁聽說他臥床，帶兵來攻，周瑜撐起來巡營激勵將士，曹仁退兵。兩軍相持一年多，曹仁棄城而走，孫權任周瑜為南郡太守。',
    src: '《三國志·吳書·周瑜傳》〈呂蒙傳〉〈甘寧傳〉〈吳主傳〉',
  },
  'zhouyu-4': {
    sides: [
      { f: 'wu', n: '孫權', l: '周瑜、孫瑜（奮威將軍）' },
      { f: 'lz', n: '劉璋', l: '益州牧劉璋（取蜀的目標，未交戰）' },
    ],
    before: '周瑜以偏將軍領南郡太守，屯據江陵。他到京口見孫權，建議和奮威將軍孫瑜一起進取蜀地，再兼併張魯、結援馬超，自己回來和孫權據襄陽逼曹操。孫權答應了。',
    after: '周瑜回江陵準備行裝，在往巴丘的路上病逝，年三十六。孫權穿素服舉哀，龐統送喪回吳；取蜀的計畫就此停下。孫權稱帝後說：「孤非周公瑾，不帝矣。」（裴注引《江表傳》）',
    src: '《三國志·吳書·周瑜傳》；〈蜀書·龐統傳〉；裴注引《江表傳》',
  },
};
